<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Eğitmen Güncelleme Formu">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span><strong>Not:</strong> Güncellenecek eğitmen bağlantı linki
                benzersiz olmalıdır...</span>
            </div>
          </b-alert>
          <b-button class="float-right" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" to="/educators">
            Eğitmen Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Eğitmen Özellikleri">
            <b-row>
              <b-col md="2">
                <b-form-checkbox v-model="isEducator" checked="true" switch inline>
                  Eğitmen
                </b-form-checkbox>
              </b-col>
              <b-col md="2">
                <b-form-checkbox v-model="isWriter" checked="true" switch inline>
                  Yazar
                </b-form-checkbox>
              </b-col>
              <b-col md="2">
                <validation-provider #default="{ errors }" name="Gizle">
                  <b-form-checkbox v-model="visibility" switch inline>
                    Listede Göster
                  </b-form-checkbox>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-col>
            </b-row>
          </b-card>
          <b-card class="mb-3" title="Eğitmen Ekleme Formu">
            <b-row>
              <b-col cols="6">
                <b-form-group label="Ad" label-for="firstName">
                  <validation-provider #default="{ errors }" :rules="{ required: true }" name="Ad">
                    <b-form-input id="firstName" v-model="firstName" placeholder="Ad"
                      :state="errors.length > 0 ? false : null" :class="
                        firstName.length >= chars.firstName ? 'text-danger' : ''
                      " />
                    <small class="textarea-counter-value float-right" :class="
                      firstName.length >= chars.firstName ? 'bg-danger' : ''
                    ">
                      <span class="char-count">{{ firstName.length }}</span>
                      /
                      {{ chars.firstName }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Soyad" label-for="lastName">
                  <validation-provider #default="{ errors }" :rules="{ required: true }" name="Ad">
                    <b-form-input id="lastName" v-model="lastName" placeholder="Soyad"
                      :state="errors.length > 0 ? false : null" :class="
                        lastName.length >= chars.lastName ? 'text-danger' : ''
                      " />
                    <small class="textarea-counter-value float-right" :class="
                      lastName.length >= chars.lastName ? 'bg-danger' : ''
                    ">
                      <span class="char-count">{{ lastName.length }}</span>
                      /
                      {{ chars.lastName }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Bağlantı Başlığı" label-for="linktTitle">
                  <validation-provider #default="{ errors }" :rules="{ required: true }" name="Bağlantı Başlığı">
                    <b-form-input id="linkTitle" v-model="linkTitle" placeholder="Bağlantı Başlığı"
                      :state="errors.length > 0 ? false : null" :class="
                        linkTitle.length >= chars.linkTitle ? 'text-danger' : ''
                      " />
                    <small class="textarea-counter-value float-right" :class="
                      linkTitle.length >= chars.linkTitle ? 'bg-danger' : ''
                    ">
                      <span class="char-count">{{ linkTitle.length }}</span>
                      /
                      {{ chars.linkTitle }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Ünvan" label-for="title">
                  <validation-provider #default="{ errors }" :rules="{ required: true }" name="Ünvan">
                    <b-form-input id="title" v-model="title" placeholder="Ünvan"
                      :state="errors.length > 0 ? false : null"
                      :class="title.length >= chars.title ? 'text-danger' : ''" />
                    <small class="textarea-counter-value float-right"
                      :class="title.length >= chars.title ? 'bg-danger' : ''">
                      <span class="char-count">{{ title.length }}</span>
                      /
                      {{ chars.linkTitle }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="İçerik" label-for="text">
                  <!-- <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="İçerik"
                  > -->
                  <editor v-if="isLoaded" ref="refEditor" :text="text"></editor>
                  <!-- <quill-editor
                      id="text"
                      v-model="text"
                      :options="snowOption"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider> -->
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <DragDropImage v-if="educator != null" ref="refCardImage" title="Kart Görseli" :required="false"
                  :imageUrl="educator.images.hero">
                </DragDropImage>
              </b-col>
              <b-col md="8">
                <b-form-group label="Görsel Başlığı (title)" label-for="imageTitle">
                  <validation-provider #default="{ errors }" :rules="{ required: true }" name="Görsel Başlığı (title)">
                    <b-form-textarea id="imageTitle" v-model="imageTitle" placeholder="Görsel Başlığı (title)" rows="3"
                      class="char-textarea" :state="errors.length > 0 ? false : null" :class="
                        imageTitle.length >= chars.imageTitle
                          ? 'text-danger'
                          : ''
                      " />
                    <small class="textarea-counter-value float-right" :class="
                      imageTitle.length >= chars.imageTitle ? 'bg-danger' : ''
                    ">
                      <span class="char-count">{{ imageTitle.length }}</span>
                      /
                      {{ chars.imageTitle }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group label="Görsel Açıklaması (alt text)" label-for="imageAltText">
                  <validation-provider #default="{ errors }" :rules="{ required: true }"
                    name="Görsel Açıklaması (alt text)">
                    <b-form-textarea id="imageAltText" v-model="imageAltText" placeholder="Görsel Açıklaması (alt text)"
                      rows="3" class="char-textarea" :state="errors.length > 0 ? false : null" :class="
                        imageAltText.length >= chars.imageAltText
                          ? 'text-danger'
                          : ''
                      " />
                    <small class="textarea-counter-value float-right" :class="
                      imageAltText.length >= chars.imageAltText
                        ? 'bg-danger'
                        : ''
                    ">
                      <span class="char-count">{{ imageAltText.length }}</span>
                      /
                      {{ chars.imageAltText }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <DragDropImage v-if="educator != null" ref="refPortraitImage" title="Kart Görseli (portrait)"
                  :required="false" :imageUrl="educator.images.portrait">
                </DragDropImage>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Bağlantı Linki" label-for="slug">
                  <validation-provider #default="{ errors }" rules="required" name="Bağlantı Linki">
                    <b-form-input id="slug" v-model="slug" placeholder="Bağlantı Linki"
                      :state="errors.length > 0 || availability == false ? false : null"
                      :class="slug.length >= chars.slug || availability == false ? 'text-danger' : ''" />
                    <small class="textarea-counter-value float-right"
                      :class="slug.length >= chars.slug ? 'bg-danger' : ''">
                      <span class="char-count">{{ slug.length }}</span>
                      /
                      {{ chars.slug }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <div v-if="availability == false">
                    <p class="text-danger"><small>İçerik linki benzersiz olmalıdır.</small></p>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Meta Açıklaması" label-for="metaTitle">
                  <validation-provider #default="{ errors }" :rules="{ required: true, min: 30 }"
                    name="Meta Açıklaması">
                    <b-form-textarea id="metaTitle" v-model="metaDescription" placeholder="Meta Açıklaması" rows="3"
                      class="char-textarea" :state="errors.length > 0 ? false : null" :class="
                        metaDescription.length >= chars.metaDescription
                          ? 'text-danger'
                          : ''
                      " />
                    <small class="textarea-counter-value float-right" :class="
                      metaDescription.length >= chars.metaDescription
                        ? 'bg-danger'
                        : ''
                    ">
                      <span class="char-count">{{
                          metaDescription.length
                      }}</span>
                      /
                      {{ chars.metaDescription }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="mt-5">
                <b-button class="float-left mt-2" v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
                  @click="postConfirmText(true, true)">Önizleme </b-button>
              </b-col>
              <b-col md="6" class="mt-5">
                <div>
                  <b-button class="float-right mt-2" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success" @click="postConfirmText(false, false)">
                    <b-spinner v-if="spinner === true && isDraft === false" small />
                    {{ spinner === true && isDraft === false ? "Yayınlanıyor" : "Yayınla" }}
                  </b-button>
                </div>
                <div>
                  <b-button class="float-right mt-2 mr-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-warning" @click="postConfirmText(true, false)">
                    <b-spinner v-if="spinner == true && isDraft == true" small />
                    {{ spinner == true && isDraft == true ? "Taslağa Kaydediliyor" : "Taslağa Kaydet" }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import Editor from "../components/Editor";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import settings from '../../../settings';
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    Editor,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      slug: "",
      text: "",
      title: "",
      image: null,
      isDraft: false,
      educator: null,
      firstName: "",
      lastName: "",
      linkTitle: "",
      imageTitle: "",
      imageAltText: "",
      featuredImage: require("@/assets/images/placeholder/1920x1080.jpg"),
      metaDescription: "",
      spinner: false,
      slugParam: this.$route.params.slugParam,
      targetLocale: this.$route.query.targetLocale,
      isEducator: true,
      isWriter: false,
      availability: true,
      visibility: true,
      chars: {
        slug: 255,
        title: 255,
        firstName: 255,
        lastName: 255,
        linkTitle: 55,
        imageTitle: 60,
        imageAltText: 140,
        metaDescription: 160,
      },
      isLoaded: false,
    };
  },
  watch: {
    slug(newSlug, oldSlug) {
      this.slugAvailability(newSlug);
    },
    firstName(newFirstName, oldFirstName) {
      this.slug = this.slugify(
        `${newFirstName} ${this.lastName} ${this.targetLocale}`
      );
      this.linkTitle = `${newFirstName} ${this.lastName}`;
      this.imageTitle = `${newFirstName} ${this.lastName}`;
      this.imageAltText = `${newFirstName} ${this.lastName}`;
    },
    lastName(newLastName, oldLastName) {
      this.slug = this.slugify(
        `${this.firstName} ${newLastName} ${this.targetLocale}`
      );
      this.linkTitle = `${this.firstName} ${newLastName}`;
      this.imageTitle = `${this.firstName} ${newLastName}`;
      this.imageAltText = `${this.firstName} ${newLastName}`;
    },
  },
  methods: {
    slugify(text, ampersand = "and") {
      const a = "àáäâèéëêıìíïîòóöôùúüûñçßÿỳýœæŕśşńṕẃǵğǹḿǘẍźḧ";
      const b = "aaaaeeeeiiiiioooouuuuncsyyyoarssnpwggnmuxzh";
      const p = new RegExp(a.split("").join("|"), "g");
      return text
        .toString()
        .toLowerCase()
        .replace(/[\s_]+/g, "-")
        .replace(p, (c) => b.charAt(a.indexOf(c)))
        .replace(/&/g, `-${ampersand}-`)
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-")
        .replace(/^-+|-+$/g, "");
    },
    slugAvailability(slug) {
      let formData = new FormData();
      formData.append("id", this.educator.id);
      formData.append("slug", slug);
      endpoints
        .postEducatorsAvailability(formData, this.targetLocale, () => { })
        .then((data) => {
          this.availability = data.response.availability
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleImageUpload(event) {
      this.image = event.target.files[0];
    },

    postConfirmText(isDraft, preview) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Güncelleme?",
        text: "Eğitmeni güncellemek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit(preview);
        }
      });
    },
    postSubmit(preview) {
      if (this.availability) {
        if (this.isWriter == false && this.isEducator == false) {
          this.$swal({
            title: "Uyarı!",
            text: "Eğitmen veya Yazar seçili olmalıdır!",
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: "Tamam!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
            }
          });
        } else {
          this.$refs.rules.validate().then((success) => {
            if (success) {
              this.spinner = true;
              let formData = new FormData();
              formData.append("id", this.educator.id);
              formData.append("slug", this.slug);
              formData.append("text", JSON.stringify(this.$refs.refEditor.value));
              formData.append("title", this.title);
              formData.append("firstName", this.firstName);
              formData.append("lastName", this.lastName);
              formData.append("isDraft", this.isDraft);
              formData.append("linkTitle", this.linkTitle);
              formData.append("isEducator", this.isEducator);
              formData.append("visibility", this.visibility);
              formData.append("isWriter", this.isWriter);
              formData.append("imageTitle", this.imageTitle);
              formData.append("imageAltText", this.imageAltText);
              formData.append("metaDescription", this.metaDescription);
              if (this.$refs.refCardImage.image) {
                formData.append("image", this.$refs.refCardImage.image);
              }
              if (this.$refs.refPortraitImage.image) {
                formData.append("portrait", this.$refs.refPortraitImage.image);
              }
              endpoints
                .putEducators(formData, this.targetLocale, () => { })
                .then((data) => {
                  this.spinner = false;

                  if (preview == true) {
                    window.open(`${settings.uiBaseUrl}/educators/preview/${this.slug}?hl=${this.targetLocale}`, '_blank');
                  }

                  this.$swal({
                    icon: "success",
                    title: "Güncelleme başarılı!",
                    text: "Eğitmen güncellendi.",
                    customClass: {
                      confirmButton: "btn btn-success",
                    },
                  }).then((result) => {
                    if (result.value) {
                      this.$router.push({
                        path: `/educators`,
                      });
                    }
                  });
                })
                .catch((err) => {
                  this.spinner = false;
                  console.log(err);
                });
            }
          });
        }
      } else {
        this.$swal({
          title: 'Hata!',
          text: 'İçerik bağlantı linki benzersiz değil!',
          icon: 'error',
          confirmButtonText: "Tamam",
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        }).then((result) => {
          if (result.value) {

          }
        });
      }
    },
  },
  created() { },
  destroyed() { },
  mounted() {
    setTimeout(() => {
      endpoints
        .getEducatorsBySlug(this.slugParam, this.targetLocale, () => { })
        .then((data) => {
          this.educator = data.response;
          this.slug = this.educator.slug;
          this.text = this.educator.text;
          this.title = this.educator.title;
          this.firstName = this.educator.firstName;
          this.lastName = this.educator.lastName;
          this.linkTitle = this.educator.seo.linkTitle;
          this.isEducator = this.educator.isEducator;
          this.isWriter = this.educator.isWriter;
          this.visibility = this.educator.visibility;
          this.imageTitle = this.educator.seo.imageTitle;
          this.imageAltText = this.educator.seo.imageAltText;
          this.metaDescription = this.educator.seo.metaDescription;
          this.featuredImage = this.educator.images.hero;
          this.portraitUrl = this.educator.images.portrait;
          this.isLoaded = true;
        })
        .catch((err) => {
          console.log(err);
        });
    }, 200);
  },
  setup() { },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
